registerComponent("sections/slider-insights", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * O slick de 2020 (`slidesToShow: 3` / `slidesToScroll: 3`, `2` a partir do
 * `breakpoint: 767` e `1` a partir do `breakpoint: 600`, `infinite: false`,
 * `arrows` e `dots` apontando para o `blocks/slider-controls` acima) vira um
 * `Asa.trilho`. O passo continua sendo a JANELA inteira (`passo: 'pagina'`, o
 * `slidesToScroll === slidesToShow` do legado), e quantos cabem por janela quem
 * diz é o CSS — o trilho MEDE, não recebe.
 *
 * ⚠️ Nenhum `matchMedia` aqui. Os dois degraus (3→2 em 767 e 2→1 em 600) moram
 * no `_slider-insights.less`, e o trilho lê deles o `slidesToShow` e o
 * `scroll-snap-type`; JS e CSS não podem discordar por um pixel.
 *
 * ⚠️ QUATRO INSTÂNCIAS NA MESMA PÁGINA em `/videos` (uma por tema em destaque),
 * mais uma em `pages/product-internal` (Fase 8). Cada uma tem o seu
 * `blocks/slider-controls` DENTRO da própria raiz, então as setas e os pontos
 * saem sempre de `component.querySelector(...)` — nunca de `document`.
 */

const lista = component.querySelector('.slider');

if (lista) {
    Asa.trilho(lista, Object.assign(
        { itens: '[data-component-name="blocks/card-content"]', passo: 'pagina' },
        Asa.controlesDoTrilho(component.querySelector('[data-component-name="blocks/slider-controls"]')),
    ));
}

});
